import React from 'react';
import ChoiceEstablishment from "../../ChoiceEstablishment/ChoiceEstablishment";
import { useDispatch, useSelector } from "react-redux";
import {
    discountFormAction,
    paymentMethodsFormAction,
    settingsTabAction,
    subscriptionConstraintFormAction,
    subscriptionDurationFormAction,
    subscriptionTypeFormAction,
    subscriptionWorkoutsFormAction,
    typeOpenSettingsFormAction
} from "../../../redux/rootReducer";
import {
    PAYMENT_METHODS_FORM_INITIAL,
    SUBSCRIPTION_CONSTRAINT_FORM_INITIAL,
    SUBSCRIPTION_DURATION_FORM_INITIAL,
    SUBSCRIPTION_TYPE_FORM_INITIAL
} from "../../../redux/initialStateConstant";

const SettingsHeader = () => {
    const dispatch = useDispatch();
    const settings_tab = useSelector(state => state.settings_tab);
    const user = useSelector(state => state.user);

    return (
        <>
            <div className="tabs tabs--settings">
                <div className={ `tab ${ settings_tab === 'establishment' ? 'tab--active' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('establishment')) }
                >
                    Заведение
                </div>
                <div className={ `tab ${ settings_tab === 'subscription_types' ? 'tab--active tab--active-added' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('subscription_types')) }
                >
                    <div className="tab__add"
                        onClick={ () => {
                            dispatch(typeOpenSettingsFormAction('types'));
                            dispatch(subscriptionTypeFormAction(SUBSCRIPTION_TYPE_FORM_INITIAL));
                        } }
                    />
                    Типы абонементов
                </div>
                <div className={ `tab ${ settings_tab === 'subscription_durations' ? 'tab--active tab--active-added' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('subscription_durations')) }
                >
                    <div className="tab__add" onClick={ () => {
                        dispatch(typeOpenSettingsFormAction('duration'));
                        dispatch(subscriptionDurationFormAction(SUBSCRIPTION_DURATION_FORM_INITIAL));
                    } } />
                    Сроки действия
                </div>
                <div className={ `tab ${ settings_tab === 'subscription_constraints' ? 'tab--active tab--active-added' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('subscription_constraints')) }
                >
                    <div className="tab__add" onClick={ () => {
                        dispatch(typeOpenSettingsFormAction('constraints'));
                        dispatch(subscriptionConstraintFormAction(SUBSCRIPTION_CONSTRAINT_FORM_INITIAL));
                    } } />
                    Ограничения
                </div>
                <div className={ `tab ${ settings_tab === 'subscription_workouts_count' ? 'tab--active tab--active-added' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('subscription_workouts_count')) }
                >
                    <div className="tab__add" onClick={ () => {
                        dispatch(typeOpenSettingsFormAction('workouts'));
                        dispatch(subscriptionWorkoutsFormAction({
                            id: '',
                            name: '',
                            count: 0,
                            unlim: '0',
                            establishments: []
                        }));
                    } } />
                    Количество занятий
                </div>
                <div className={ `tab ${ settings_tab === 'payment_methods' ? 'tab--active tab--active-added' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('payment_methods')) }
                >
                    <div className="tab__add" onClick={ () => {
                        dispatch(typeOpenSettingsFormAction('payment_methods'));
                        // Очистка формы платёжных методов
                        dispatch(paymentMethodsFormAction(PAYMENT_METHODS_FORM_INITIAL));
                    } } />
                    Методы оплаты
                </div>
                <div className={ `tab ${ settings_tab === 'discount' ? 'tab--active tab--active-added' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('discount')) }
                >
                    <div className="tab__add" onClick={ () => {
                        dispatch(typeOpenSettingsFormAction('discount'));
                        // Очистка формы платёжных методов
                        dispatch(discountFormAction({
                            id: '',
                            name: '',
                            percent: '',
                            establishments: []
                        }));
                    } } />
                    Скидки
                </div>
                <div className={ `tab ${ settings_tab === 'other' ? 'tab--active' : '' }` }
                     onClick={ () => dispatch(settingsTabAction('other')) }
                >
                    Прочие настройки
                </div>
                {
                    user.role === 'super_admin' &&
                    <div className={ `tab ${ settings_tab === 'remove_data' ? 'tab--active' : '' }` }
                         onClick={ () => dispatch(settingsTabAction('remove_data')) }
                    >
                        Удаление данных
                    </div>
                }
            </div>
            <ChoiceEstablishment/>
        </>
    );
};

export default SettingsHeader;